(() => {
  const topics = document.querySelector('[id^="BlogTopics--"]');
  const articleGrid = document.querySelector('[id^="BlogArticles--"]');
  const blogPagination = document.querySelector('[id^="BlogPagination--"]');
  const currentBlogPath = '/blogs/news';

  if (!topics || !articleGrid) return;

  const topicQueries = {
    'gut-health': 'gut health',
    kombucha: 'kombucha',
    probiotics: 'probiotics',
    nutrition: 'nutrition',
    wellness: 'wellness',
    hydration: 'hydration',
    exercise: 'exercise',
    fiber: 'fiber',
    recipes: 'recipes',
    'healthy-lifestyle': 'healthy lifestyle'
  };

  const selectedTopic = new URLSearchParams(window.location.search).get('topic');
  const query = topicQueries[selectedTopic];
  const selectedLink = selectedTopic && topics.querySelector(`[data-blog-topic="${selectedTopic}"]`);

  if (!query || !selectedLink) return;

  selectedLink.classList.add('is-active');
  articleGrid.classList.add('main-blog__topic-loading');
  blogPagination?.classList.add('main-blog__topic-loading');
  articleGrid.setAttribute('aria-busy', 'true');

  const currentPage = Number(new URLSearchParams(window.location.search).get('page')) || 1;
  const pageSize = 6;
  const searchUrl = (page) => `/search?q=${encodeURIComponent(query)}&type=article&page=${page}`;

  const isCurrentBlogArticle = (result) => {
    const articleLink = result.querySelector('a[href*="/blogs/"]');
    if (!articleLink) return false;

    const articlePath = new URL(articleLink.href, window.location.origin).pathname;
    return articlePath.startsWith(`${currentBlogPath}/`) && !articlePath.startsWith('/blogs/kobu-retailer-education/');
  };

  const getSearchPage = (page) =>
    fetch(searchUrl(page))
      .then((response) => {
        if (!response.ok) throw new Error('Unable to load blog search results');
        return response.text();
      })
      .then((html) => {
        const searchDocument = new DOMParser().parseFromString(html, 'text/html');
        const searchGrid = searchDocument.querySelector('#product-grid');
        const searchPagination = searchDocument.querySelector('.pagination-wrapper');
        const results = searchGrid
          ? Array.from(searchGrid.querySelectorAll('#product-grid > ul > li')).filter(isCurrentBlogArticle)
          : [];
        const searchPages = searchPagination
          ? Array.from(searchPagination.querySelectorAll('a[href]'))
              .map((link) => Number(new URL(link.href, window.location.origin).searchParams.get('page')) || 1)
          : [];

        return { results, totalPages: Math.max(1, page, ...searchPages) };
      });

  getSearchPage(1)
    .then((firstPage) => {
      const remainingPages = Array.from({ length: firstPage.totalPages - 1 }, (_, index) => getSearchPage(index + 2));
      return Promise.all(remainingPages).then((pages) => [firstPage, ...pages]);
    })
    .then((pages) => {
      const allResults = pages.flatMap((page) => page.results);
      const filteredPageCount = Math.max(1, Math.ceil(allResults.length / pageSize));
      const pageStart = (currentPage - 1) * pageSize;
      const pageResults = allResults.slice(pageStart, pageStart + pageSize);

      if (!pageResults.length) {
        articleGrid.innerHTML = '<p class="main-blog__topics-empty">No blog posts found for this topic.</p>';
      } else {
        const blogArticles = pageResults.map((result) => {
          const article = document.createElement('div');
          article.className = 'blog-articles__article article';
          article.innerHTML = result.innerHTML;
          return article;
        });
        articleGrid.replaceChildren(...blogArticles);
      }

      if (blogPagination) {
        const originalPagination = blogPagination.querySelector('.pagination-wrapper');
        const originalList = originalPagination?.querySelector('.pagination__list');
        if (!originalPagination || !originalList || filteredPageCount < 2) {
          blogPagination.hidden = true;
          return;
        }

        const previousArrow = originalPagination.querySelector('.pagination__item--next .svg-wrapper');
        const nextArrow = originalPagination.querySelector('.pagination__item--prev .svg-wrapper');
        const paginationItems = [];
        const pageUrl = (page) => `${window.location.pathname}?topic=${encodeURIComponent(selectedTopic)}${page === 1 ? '' : `&page=${page}`}`;

        const addPage = (page) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.textContent = page;
          link.className = `pagination__item ${page === currentPage ? 'pagination__item--current light' : 'link'}`;
          link.href = pageUrl(page);
          link.setAttribute('aria-label', `Page ${page}`);
          if (page === currentPage) {
            link.setAttribute('role', 'link');
            link.setAttribute('aria-disabled', 'true');
            link.setAttribute('aria-current', 'page');
          }
          item.appendChild(link);
          paginationItems.push(item);
        };

        const addEllipsis = () => {
          const item = document.createElement('li');
          const span = document.createElement('span');
          span.className = 'pagination__item';
          span.textContent = '…';
          item.appendChild(span);
          paginationItems.push(item);
        };

        if (currentPage > 1) {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = pageUrl(currentPage - 1);
          link.className = 'pagination__item pagination__item--next pagination__item-arrow link motion-reduce';
          link.setAttribute('aria-label', 'Previous page');
          if (previousArrow) link.appendChild(previousArrow.cloneNode(true));
          item.appendChild(link);
          paginationItems.push(item);
        }

        const pageNumbers = filteredPageCount <= 5
          ? Array.from({ length: filteredPageCount }, (_, index) => index + 1)
          : currentPage <= 3
            ? [1, 2, 3, 'ellipsis', filteredPageCount]
            : currentPage >= filteredPageCount - 2
              ? [1, 'ellipsis', filteredPageCount - 2, filteredPageCount - 1, filteredPageCount]
              : [1, 'ellipsis', currentPage, 'ellipsis', filteredPageCount];

        pageNumbers.forEach((page) => (page === 'ellipsis' ? addEllipsis() : addPage(page)));

        if (currentPage < filteredPageCount) {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = pageUrl(currentPage + 1);
          link.className = 'pagination__item pagination__item--prev pagination__item-arrow link motion-reduce';
          link.setAttribute('aria-label', 'Next page');
          if (nextArrow) link.appendChild(nextArrow.cloneNode(true));
          item.appendChild(link);
          paginationItems.push(item);
        }

        originalList.replaceChildren(...paginationItems);
        blogPagination.hidden = false;
      }
    })
    .catch(() => {
      // Keep the normal blog articles visible if the search request fails.
    })
    .finally(() => {
      articleGrid.classList.remove('main-blog__topic-loading');
      blogPagination?.classList.remove('main-blog__topic-loading');
      articleGrid.removeAttribute('aria-busy');
    });
})();
